import { Loader2 } from 'lucide-react';
import { cn } from '@/utils';

interface SignOutLoadingOverlayProps {
	isHomePage: boolean;
}

export function SignOutLoadingOverlay({ isHomePage }: SignOutLoadingOverlayProps) {
	return (
		<div
			aria-live="polite"
			aria-label="Signing out"
			className={cn(
				'fixed inset-0 z-[9999] flex min-h-dvh flex-col items-center justify-center gap-3',
				isHomePage ? 'home-inter-font bg-[#f4f6fc] text-[#111834]' : 'bg-[#101423] text-white'
			)}
		>
			<Loader2 aria-hidden="true" className="size-8 animate-spin text-[#2667ff]" />
			<p className="text-sm font-semibold">Signing out...</p>
		</div>
	);
}
